export default __webpack_public_path__ + "announcement-box.png";